export default "<pin-call-tooltip></pin-call-tooltip>\r\n<pin-chat-tooltip></pin-chat-tooltip>\r\n";